import React, { useState, useContext, useEffect } from "react";
import HeaderStats from "./Common/Header";
import FiltersStats from "./Common/Filters";
import produitDataFetcher from "dataProvider/Produit";
import { ListProvider } from "context/List/Context";
import ListStats from "./List";
import ViewData from "./ViewData";
import { IntlContext } from "context";

const StatsRouter: React.FC = () => {
    const intl = useContext(IntlContext);
    enum displayView {
        STATS = "stats",
        DATA = "data",
    }
    const [activeFilters, setActiveFilters] = useState<FiltersStatsInterface>();
    const [filtersMax, setFiltersMax] = useState<FiltersMaxStatsInterface>({} as FiltersMaxStatsInterface);
    const [tab, setTab] = useState<displayView.STATS | displayView.DATA>(
        activeFilters?.filter_display_type.slice().shift() ?? displayView.STATS
    );

    useEffect(() => {
        setTab(activeFilters?.filter_display_type.slice().shift());
    }, [activeFilters]);

    return (
        <React.Fragment>
            <ListProvider
                dataFetcher={produitDataFetcher.stats}
                defaultFetcherParams={{ order: "libel", direction: "asc" }}
                defaultFetch={false}
            >
                <HeaderStats />
                <FiltersStats setActiveFilters={setActiveFilters} setFiltersMax={setFiltersMax} filtersMax={filtersMax} />

                <div className="stats" style={{ marginTop: "50px", marginBottom: "150px" }}>
                    <div className="container container--table bloc_tabs">
                        <ul className="nav-tabs">
                            {activeFilters?.filter_display_type?.includes(displayView.STATS) && (
                                <li
                                    className={`tab ${tab === displayView.STATS ? "active" : ""}`}
                                    onClick={() => setTab(displayView.STATS)}
                                >
                                    {intl.formatMessage("produit.stats.descriptives.title")}
                                </li>
                            )}
                            {activeFilters?.filter_display_type?.includes(displayView.DATA) && (
                                <li
                                    className={`tab ${tab === displayView.DATA ? "active" : ""}`}
                                    onClick={() => setTab(displayView.DATA)}
                                >
                                    {intl.formatMessage("produit.view_data.display_data")}
                                </li>
                            )}
                        </ul>
                        <div className="bloc">
                            {tab === displayView.STATS &&
                                activeFilters?.filter_display_type?.includes(displayView.STATS) && (
                                    <ListStats activeFilters={activeFilters} />
                                )}
                            {tab === displayView.DATA &&
                                activeFilters?.filter_display_type?.includes(displayView.DATA) && (
                                    <ViewData activeFilters={activeFilters} filtersMax={filtersMax} />
                                )}
                        </div>
                    </div>
                </div>
            </ListProvider>
        </React.Fragment>
    );
};

export default StatsRouter;
